import React, { useCallback, useState } from "react";
import { login } from "../store/auth/AuthActions.js";
import { useDispatch } from "react-redux";

import logoUrl from "img/zeta-logo.png";
import { Links } from "./Links.jsx";

export const LoginForm = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [ email, setEmail ] = useState("");
    const [ password, setPassword ] = useState("");

    const dispatch = useDispatch();

    const onSubmit = useCallback((e) => {
        e.preventDefault();

        setError(null);
        setLoading(true);
        dispatch(login(email, password)).then(()=>{
            console.log("Successful authentication");
            setLoading(false);
            location.href = "/#/";
        }, (e)=>{
            console.error(e);
            setLoading(false);
            setError(e.toString());
        })
    }, [email, password]);

    let body = null;

    if(loading){
        body = (
            <div id="loading-display">
                <p><i className="fa fa-spinner fa-pulse fa-2x"></i></p>
                <h2>Signing in...</h2>
            </div>
        );
    }else{
        body = (
            <div id="login-form">
                <label htmlFor="inputEmail" className="sr-only">Email address</label>
                <input value={email} onChange={ ev => setEmail(ev.target.value) } type="email" id="inputEmail" className="form-control" placeholder="Email address" required />
                <label htmlFor="inputPassword" className="sr-only">Password</label>
                <input value={password} onChange={ ev => setPassword(ev.target.value) }  type="password" id="inputPassword" className="form-control" placeholder="Password" required />
                <div id="button-box">
                    <button className="btn btn-lg btn-primary btn-block" id="signin" type="submit">Log In</button>
                    <a href="#/register" className="btn btn-lg btn-block" id="register">Register</a>
                    <a href="#/resetpass" className="btn btn-lg btn-block" id="resetpass">Reset Password</a>
                </div>
            </div>
        );
    }

    return (
        <form className="form-signin" id="login" onSubmit={onSubmit}>
            <img className="zeta-logo" src={logoUrl}/>
            <h3>Zeta Remote</h3>
            {error ? 
                <div className="alert alert-danger" role="alert" id="error-message">Login failed: incorrect email address or password entered</div>
                :
                null
            }
            {body}
            <Links/>
        </form>
    )
}